import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames/bind'

import FullMap from '../../searchResults/components/FullMap/FullMap'
import SlideHotelItem from "../../searchResults/components/Slide/SlideItem";
import setValue from '../../shared/actions/setValue'
import getSearchResults from '../../shared/actions/getSearchResults'
import Button from '../../shared/Button';

import styles from './DestinationFullMap.module.scss'

const cx = classnames.bind(styles)
const btnText = drupalSettings?.destinationMap?.viewText;

const DestinationFullMap = function ({
   results,
   getSearchResultsAction,
   setValueAction
}) {
  const handleFMapClick = () => {
    setValueAction('fullMap', true)
  }

  useEffect(() => {
    getSearchResultsAction(null, true)
  }, []);

  return (
    <div className={cx('btn-holder')}>
      <FullMap
        fullMap
        isDestination
        itemComponent={SlideHotelItem}
      />
      {!!results?.length && (
        <Button
          type="button"
          className={cx('show-full-map')}
          color="black-reverse"
          theme="squared"
          onClick={handleFMapClick}
        >
          <i className="icon icon-map" />
          {btnText}
        </Button>
      )}
    </div>
  )
}

export default connect(({ main: { results } }) => ({ results }), {
  setValueAction: setValue,
  getSearchResultsAction: getSearchResults,
})(DestinationFullMap)
